import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/operator/routing/nodes/")({
  beforeLoad: ({ location }) => {
    throw redirect({
      to: "/app/operator/routing",
      search: { view: "nodes" },
      hash: location.hash,
      replace: true,
    });
  },
});
